import type ISessionVCItem from 'store/slices/valueChainMap/interfaces/ISessionVCItem';

export const getSessionTemplateTitle = (
  session?: Pick<ISessionVCItem, 'agentConfigName' | 'agentConfig'> | null,
): string => {
  const nestedName = session?.agentConfig?.name?.trim() || '';
  const flatName = session?.agentConfigName?.trim() || '';

  return flatName || nestedName;
};

export const formatSessionChromeTitle = ({
  baseTitle,
  templateTitle,
  formattedDate,
}: {
  baseTitle: string,
  templateTitle?: string,
  formattedDate?: string,
}): string => {
  const withTemplate = templateTitle
    ? `${baseTitle} · ${templateTitle}`
    : baseTitle;

  if (!formattedDate) {
    return withTemplate;
  }

  return `${withTemplate} [${formattedDate}]`;
};
